<script lang="ts">
  import { Swiper, SwiperSlide } from 'swiper/svelte'
  import { Pagination, Navigation } from 'swiper'
  import 'swiper/css'
  import 'swiper/css/pagination'
  import 'swiper/css/navigation'
  import cornerTopLeft from 'src/components/main/#assets/top-left-border.svg'
  import cornerTopRight from 'src/components/main/#assets/top-right-border.svg'
  import cornerBottomLeft from 'src/components/main/#assets/bottom-left-border.svg'
  import cornerBottomRight from 'src/components/main/#assets/bottom-right-border.svg'
  import backgroundTop from './background-top.jpg'
  import backgroundCenter from './background-center.jpg'
  import backgroundBottom from './background-bottom.jpg'
  import card from './card.svg'
  import card1 from './card-1.svg'
  import card2 from './card-2.svg'
  import card3 from './card-3.svg'
  import card4 from './card-4.svg'
  import leftArrow from './left.svg'
  import rightArrow from './right.svg'

  let swiper
</script>

<section class="anatomy" id="meowgon-anatomy" style="
    --backgroundTop: url({backgroundTop});
    --backgroundCenter: url({backgroundCenter});
    --backgroundBottom: url({backgroundBottom});
">
    <div class="container">
        <div class="title">
            Meowgon Anatomy
            <div class="corner top-left" style="--cornerTopLeft: url({cornerTopLeft});"></div>
            <div class="corner top-right" style="--cornerTopRight: url({cornerTopRight});"></div>
            <div class="corner bottom-left" style="--cornerBottomLeft: url({cornerBottomLeft});"></div>
            <div class="corner bottom-right" style="--cornerBottomRight: url({cornerBottomRight});"></div>
        </div>
        <div class="row d-none d-md-flex" style="--card: url({card});">
            <div class="col-md-6 col-xl-3">
                <div class="card">
                    <img src="{card1}" class="card-icon" alt="">
                    <div class="card-description"><strong>Meowgon</strong> - a mysterious creature which is generated from 3 parts (head, body and tail). Each of those parts is responsible for a specific skill.</div>
                </div>
            </div>
            <div class="col-md-6 col-xl-3">
                <div class="card">
                    <img src="{card2}" class="card-icon" alt="">
                    <div class="card-description"><strong>There are 9 natural elements</strong> and each of them have 3 types. In total we have 27 elements, from which 19 683 unique units will be created.</div>
                </div>
            </div>
            <div class="col-md-6 col-xl-3">
                <div class="card">
                    <img src="{card3}" class="card-icon" alt="">
                    <div class="card-description"><strong>There are 5 rarities:</strong> Rare, Epic, Legendary and Supreme. Matching of two the same elements open new opportunities for players.</div>
                </div>
            </div>
            <div class="col-md-6 col-xl-3">
                <div class="card">
                    <img src="{card4}" class="card-icon" alt="">
                    <div class="card-description"><strong>Rarities drop rate:</strong><br>Supreme: 0.137%<br>Legendary: 1.235%<br>Epic: 25%<br>Rare: 73.628%</div>
                </div>
            </div>
        </div>
        <div class="d-md-none" style="
            --card: url({card});
            --leftArrow: url({leftArrow});
            --rightArrow: url({rightArrow});
        ">
            <Swiper
                modules={[Navigation, Pagination]}
                spaceBetween={16}
                slidesPerView={1}
                centeredSlides={true}
                loop={true}
                navigation
                pagination={{ clickable: false }}
                effect="fade"
                on:swiper={e => swiper = e.detail[0]}
            >
                <SwiperSlide>
                    <div class="card">
                        <img src="{card1}" class="card-icon" alt="">
                        <div class="card-description"><strong>Meowgon</strong> - a mysterious creature which is generated from 3 parts (head, body and tail). Each of those parts is responsible for a specific skill.</div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div class="card">
                        <img src="{card2}" class="card-icon" alt="">
                        <div class="card-description"><strong>There are 9 natural elements</strong> and each of them have 3 types. In total we have 27 elements, from which 19 683 unique units will be created.</div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div class="card">
                        <img src="{card3}" class="card-icon" alt="">
                        <div class="card-description"><strong>There are 5 rarities:</strong> Rare, Epic, Legendary and Supreme. Matching of two the same elements open new opportunities for players.</div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div class="card">
                        <img src="{card4}" class="card-icon" alt="">
                        <div class="card-description"><strong>Rarities drop rate:</strong><br>Supreme: 0.137%<br>Legendary: 1.235%<br>Epic: 25%<br>Rare: 73.628%</div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </div>
    </div>
</section>

<style>
    .anatomy {
        position: relative;
        padding: 422px 0 485px;
        background-image: var(--backgroundTop), var(--backgroundBottom), var(--backgroundCenter);
        background-repeat: no-repeat, no-repeat, repeat-y;
        background-position: top center, bottom center, top 17px center;
    }

    .title {
        font-size: 100px;
        font-weight: 700;
        padding: 18px 18px 0;
        background: linear-gradient(84deg, #020304 47%, #EE7B1B 71%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        line-height: normal;
        text-transform: uppercase;
        display: table;
        margin: 0 auto 100px;
        position: relative;
    }

    .corner {
        width: 15px;
        height: 15px;
        position: absolute;
        transition: .3s;
    }

    .corner.top-left {
        top: 0;
        left: 0;
        background: var(--cornerTopLeft) no-repeat top left;
    }

    .corner.top-right {
        top: 0;
        right: 0;
        background: var(--cornerTopRight) no-repeat top right;
    }

    .corner.bottom-left {
        bottom: 0;
        left: 0;
        background: var(--cornerBottomLeft) no-repeat bottom left;
    }

    .corner.bottom-right {
        bottom: 0;
        right: 0;
        background: var(--cornerBottomRight) no-repeat bottom right;
    }

    .card {
        background: var(--card) no-repeat center;
        background-size: contain;
        height: 536px;
        border: 0;
        margin: -10px;
        padding: 27px;
    }

    .card-description {
        color: #4F565E;
        font-size: 20px;
        font-weight: 400;
        line-height: 130%;
        margin-top: 20px;
    }

    .card-description strong {
        color: #020304;
        font-weight: 700;
    }

    .card-icon {
        width: 100%;
        max-width: 100%;
        height: auto;
    }

    @media(max-width: 1750px) {
        .anatomy {
            padding: 360px 0 435px;
        }

        .card {
            height: 466px;
        }

        .card-description {
            font-size: 17px;
        }
    }

    @media(max-width: 1520px) {
        .card {
            padding-top: 40px;
        }
    }

    @media(max-width: 1400px) {
        .title {
            font-size: 70px;
            margin: 0 auto 80px;
        }

        .anatomy {
            background-size: contain;
            padding: 260px 0 300px;
        }

        .card {
            height: 374px;
            padding: 25px;
        }

        .card-description {
            font-size: 14px;
            margin-top: 15px;
        }
    }

    @media(max-width: 1200px) {
        .anatomy {
            padding: 230px 0;
        }

        .card {
            height: 410px;
            margin-bottom: 40px;
        }

        .card-icon {
            width: 274px;
            margin: 0 auto;
        }

        .card-description {
            width: 274px;
            margin: 15px auto 0;
        }

        .title {
            font-size: 60px;
        }
    }

    @media(max-width: 991px) {
        .title {
            font-size: 40px;
            width: 100%;
            text-align: center;
            padding: 5px 10px 0;
            margin-bottom: 50px;
        }
    }

    @media(max-width: 767px) {
        .anatomy {
            padding: 110px 0 120px;
        }

        :global(body .swiper-button-prev) {
            top: auto;
            bottom: 0;
            width: 65px;
            height: 60px;
            background: var(--leftArrow) no-repeat center;
            z-index: 11;
            left: 50%;
            margin-left: -130px;
        }

        :global(body .swiper-button-next) {
            top: auto;
            bottom: 0;
            width: 65px;
            height: 60px;
            background: var(--rightArrow) no-repeat center;
            z-index: 11;
            left: 50%;
            margin-left: 65px;
        }

        :global(body .swiper-button-prev:after),
        :global(body .swiper-button-next:after) {
            display: none;
        }

        :global(body .swiper-pagination-bullet-active) {
            background: #020304;
        }

        :global(body .swiper-pagination-bullet) {
            width: 10px;
            height: 10px;
        }

        :global(body .swiper-slide) {
            padding-bottom: 60px;
        }

        :global(body .swiper-horizontal>.swiper-pagination-bullets) {
            bottom: 20px;
        }

        .card {
            margin: 0 0 25px;
        }
    }
</style>
